import React, { useState } from 'react';
import { Button, DialogContent, DialogTitle, DialogActions, Dialog, Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { useNotify } from '../../hooks/useNotify';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';
import { activityAutocomplete } from '../../autocomplete';
import AutocompleteSelect from '../atom/AutocompleteSelect';

function DuplicateTicketModal({
    currentActivity,
    currentTicket,
    showModal,
    MODAL_TYPE,
    onClose,
    idList,
    setIdList
}) {
    const [activity, setActivity] = useState(currentActivity);
    const [ticketName, setTicketName] = useState(null);
    const { notifySuccess, notifyError } = useNotify();

    const createTicket = () => {
        doSwaggerCall('tickets', 'createTicket', {
            newTicket: {
                vendor_sku: currentTicket.vendor_sku,
                activity_id: activity.id,
                name: ticketName,
                date_from: currentTicket.date_from,
                date_to: currentTicket.date_to,
                retail_price: currentTicket.retail_price,
                price_rules: currentTicket.price_rules,
                price_items: currentTicket.price_items,
                booking_fields: currentTicket.booking_fields,
                addonTickets: currentTicket.addonTickets,
                upgradeToTickets: currentTicket.upgradeToTickets,
                ticket_order: activity.tickets ? activity.tickets.length : 30
            }
        })
            .then(res => {
                notifySuccess('New ticket created!');
                showModal(MODAL_TYPE.NONE);
                const newIdList = [...idList];
                newIdList.push(res.ticket.id);
                setIdList(newIdList);
                onClose();
            })
            .catch(err => {
                console.log(err);
                notifyError('Error during ticket creation!');
            });
    };

    return (
        <form>
            <Dialog aria-labelledby="client-modal" open maxWidth="md">
                <DialogTitle>Duplicate new ticket</DialogTitle>
                <DialogContent>
                    <form
                        id="newticket-form"
                        onSubmit={ev => {
                            ev.preventDefault();
                            createTicket();
                        }}
                    >
                        <AutocompleteSelect
                            initCall={activityAutocomplete.init}
                            autocompleteCall={activityAutocomplete.search}
                            value={activity.id}
                            setValue={value => setActivity({ id: value })}
                            disableClearable
                        >
                            <TextField label="To activity" />
                        </AutocompleteSelect>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Ticket name"
                                    type="text"
                                    value={ticketName}
                                    onChange={ev => setTicketName(ev.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => showModal(MODAL_TYPE.NONE)}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!ticketName}
                        type="submit"
                        form="newticket-form"
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </form>
    );
}

export default DuplicateTicketModal;
